/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import nativeStyled, { css, createGlobalStyle, keyframes } from 'styled-components';

import styledFactory from 'fierry/react.old/styled/factory';
import elements from 'fierry/react.old/styled/elements';

export { default as animate } from 'fierry/react.old/styled/animate';
export { default as animateOnce } from 'fierry/react.old/styled/animate.once';

export { default as Transition } from 'fierry/react.old/styled/transition';


const styled = (...args) =>
{
  return nativeStyled(...args);
};


elements.forEach(tag =>
{
  styled[tag] = styledFactory(tag);
});


export { css, keyframes, styled, createGlobalStyle };

export default styled;
